import React, { Component } from "react";
import onClickOutside from "react-onclickoutside";

class Dropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  handleClick = () => this.setState({ open: !this.state.open });

  // used by onClickOutside
  handleClickOutside = () => this.setState({ open: false });

  render() {
    const { children, buttonStyles, trigger, align, menuStyles } = this.props;
    const { open } = this.state;

    return (
      <div className="relative">
        <button
          className={`block w-full text-black rounded leading-tight bg-white border focus:border-white-light hover:border-white-light ${buttonStyles}`}
          onClick={this.handleClick}
        >
          {trigger}
        </button>

        <div
          className={`${open ? "" : "hidden"} ${menuStyles} ${
            align && align === "right" ? "right-0" : "left-0"
          } rounded shadow-md absolute _mt-12 min-w-full bg-white overflow-hidden border border-white-light z-10`}
        >
          {children}
        </div>
      </div>
    );
  }
}

export default onClickOutside(Dropdown);
